module.exports = __webpack_public_path__ + "592aa2a8422eec1e9fca85fb9a368578.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/logo.png
// module id = 442
// module chunks = 0